import React from "react";
import Typewriter from "typewriter-effect";
import './PersonalDetails.css';
import {useIntl} from "react-intl";
import messages from "../../../i18n/messages";

const PersonalDetails = ({ageProp}) => {
    const intl = useIntl();

    return (
        <div className='personal-details'>
            <br/>
            <Typewriter
                onInit={(typewriter) => {
                    typewriter.typeString(intl.formatMessage(messages.profileDataLine1))
                        .pauseFor(500)
                        .typeString('<br/>')
                        .typeString(intl.formatMessage(messages.profileDataLine2))
                        .pauseFor(500)
                        .typeString('<br/>')
                        .typeString(intl.formatMessage(messages.profileDataLine3, {age: ageProp}))
                        .pauseFor(500)
                        .typeString('<br/>')
                        .typeString(intl.formatMessage(messages.profileDataLine4))
                        .pauseFor(500)
                        .typeString('<br/>')
                        .typeString(intl.formatMessage(messages.profileDataLine5))
                        .callFunction((state) => {
                            state.elements.cursor.remove();
                            typewriter.stop();
                        })
                        .start();
                }}
                options={{
                    loop: false,
                    cursor: '_',
                }}
            />
        </div>
    );
}

export default PersonalDetails;